<script lang="ts">
  interface Props {
    checked: boolean;
    label: string;
    onchange: (checked: boolean) => void;
    disabled?: boolean;
    /** Extra line under the label, for a preference that needs a caveat. */
    hint?: string;
  }

  let { checked, label, onchange, disabled = false, hint }: Props = $props();
</script>

<!--
  A real `role="switch"` button rather than a styled div: it gets Space/Enter,
  focus and the on/off state announced without any of that being reimplemented
  here. The pixel knob is decoration on top of a control the platform already
  understands.
-->
<button
  type="button"
  class="opt optrow"
  role="switch"
  aria-checked={checked}
  {disabled}
  onclick={() => onchange(!checked)}
>
  <span class="optrow__copy">
    <span class="optrow__label">{label}</span>
    {#if hint}<span class="optrow__hint">{hint}</span>{/if}
  </span>
  <span class="sw" class:on={checked} aria-hidden="true">
    <span class="knb" class:on={checked}></span>
  </span>
</button>
